module.exports = __webpack_public_path__ + "img/icon-plus-blue.9a687109.svg";